import {React, useState, useEffect} from 'react';
// import { useSelector } from 'react-redux';
import { Avatar } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import styles from "@containers/ViewUserPage/ViewUserPage.module.css";
// import usePostPay from '@hooks/usePostPay';

const PostPayDoctorCard = ({firstName, lastName, gender, contact, email, address, institute, pincode}) => {
  
  return (
    <div className={styles.DetailCard}>
      <div className={styles.cardHead}>
        <Avatar className={styles.avatar}>
          <AccountCircleIcon fontSize="large" />
        </Avatar>
        <h2>{firstName} {lastName}</h2>
      </div>
      <div>
        <p><strong>Gender:</strong> {gender}</p>
        <p><strong>Contact:</strong> {contact}</p>
        <p><strong>Email:</strong> {email}</p>
        <p><strong>Address:</strong> {address}</p>
        <p><strong>Institute:</strong> {institute}</p>
        <p><strong>Pincode:</strong> {pincode}</p>
      </div>
    </div>
  );
};

export default PostPayDoctorCard;